export const state = () => ({
  customNotificationMessage: "",
  customNotificationType: "",
  customNotificationParams: null,

  isOpenCustomNotification: false,
})

export const mutations = {

  openErrorNotification: function (state, {
    message, configuration
  }) {
    state.customNotificationMessage = message;
    state.isOpenCustomNotification = true;
    state.customNotificationParams = configuration || null;
  },
  closeErrorNotification: function (state) {
    state.customNotificationMessage = "";
    state.isOpenCustomNotification = false;
    state.customNotificationType = "";
    state.customNotificationParams = null;
  },

  openCustomNotification: function (state, {
    message,
    params
  }) {
    state.customNotificationMessage = message;
    state.isOpenCustomNotification = true;
    state.customNotificationType = params?.type || "";
    state.customNotificationParams = params || null;
  }

}
